import config from "@/utils/config";
import md5 from 'js-md5';
export default {
    
  /**
   * 生成签名 isJSON 参数不加密
   * @param {*} url
   * @param {*} params
   */
  genSignature(url,params,Timestamp,isJSON = false,method = "POST") {

    // console.log(params)
    let keyArr = Object.keys(params).sort()
    let parametersStr = ""
    for (let i = 0; i<keyArr.length;i++)
    {
      parametersStr+=keyArr[i]+params[keyArr[i]]+","
    }
    parametersStr  = parametersStr.substring(0, parametersStr.length - 1);
    if(parametersStr =="") //没参数就_
    parametersStr="_"
    // console.log(parametersStr)
    let toAlgorithm
  if(isJSON)
  {
    toAlgorithm =  process.env.VUE_APP_APP_KEY+process.env.VUE_APP_APP_SECRET+Timestamp+ method +url
  }
  else{
    toAlgorithm =  process.env.VUE_APP_APP_KEY+process.env.VUE_APP_APP_SECRET+Timestamp+ method +url+parametersStr
  }

    // console.log(toAlgorithm)
    return  md5(toAlgorithm) 
  },
  launageToCountryCode( launage){
    launage=launage+""
      if(launage == 'en')
      {
        return "US"
      }
     else if(launage == 'zh-cn')
      {
        return "CN"
      } 
      else{
        return launage.toUpperCase()
      }
  },


    isMoible(UA) {
        return /(Android|webOS|iPhone|iPod|tablet|BlackBerry|Mobile)/i.test(UA) ?
            true :
            false;
        },
    /**
     * 数组删除元素
     * @param {*} arr 
     * @param {*} key  匹配key
     * @param {*} equalValue   需要删除的值
     */
    delArray(arr, key, equalValue) {
        arr.splice(arr.findIndex(item => item[key] === equalValue), 1)
    },

    findArryValue(arr, key, findValue) {

        return arr.find(item => item[key] == findValue)
    },
    //校验邮箱
    checkEmail(email) {
        var reg = new RegExp(
            "^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$"
        ); //正则表达式

        if (email === "") {
            //输入不能为空

            return false;
        } else if (!reg.test(email)) {
            //正则验证不通过，格式不对

            return false;
        } else {
            return true;
        }
    },
    //校验是数字
    checkNumber(number) {
        var reg = new RegExp("^[0-9]*$"); //正则表达式
        return reg.test(number)
    }

}